import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

function initials(title: string) {
  return String(title || '?').trim().slice(0, 1).toUpperCase() || '?'
}

export function TwitterSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const media = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const mediaSrc = media?.src || media?.thumbSrc
  return (
    <>
      <div className={`md-subs-twitter-row border-b border-[#2f3336] bg-black px-4 py-3 text-[15px] text-[#e7e9ea] font-[-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,Helvetica,Arial,sans-serif] hover:bg-[rgba(255,255,255,0.03)]${display.isChecked ? ' md-subs-twitter-row--checked bg-[rgba(29,155,240,0.1)]' : ''}`}>
        <div className="md-subs-twitter-inner flex gap-3">
          <div className="md-subs-twitter-avatar flex h-10 w-10 flex-none items-center justify-center rounded-full bg-[#1d9bf0] font-bold text-white">
            {initials(display.identity.author || display.title)}
          </div>
          <div className="md-subs-twitter-main min-w-0 flex-1">
            <div className="md-subs-twitter-head flex min-w-0 items-baseline gap-2">
              <span className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap font-bold [&_.md-sub-title-link]:text-[#e7e9ea]">{controls.content.title}</span>
              <span className="flex-none text-[#71767b]">{controls.content.time}</span>
            </div>
            <div className="md-subs-twitter-text mt-1 leading-[1.4] text-[#e7e9ea] [overflow-wrap:anywhere] [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-[#e7e9ea]">
              {controls.content.text}
            </div>
            {mediaSrc ? <img className="mt-3 max-h-[520px] w-full rounded-2xl border border-[#2f3336] object-cover" src={mediaSrc} alt={media.title || media.filename || display.title} /> : null}
            <div className="md-subs-twitter-actions mt-3 flex max-w-[360px] items-center justify-between text-[13px] text-[#71767b] [&_.md-sub-meta-link]:text-[#71767b] [&_.md-sub-meta-more]:text-[#71767b]">
              {controls.actions.check}
              {controls.links.answers}
              {controls.links.submsges}
              {controls.actions.favorite}
              {controls.actions.quickReply}
            </div>
          </div>
        </div>
      </div>
      <div className="md-subs-twitter-children ml-[52px] border-l border-[#2f3336]">{slots.allChildren}</div>
    </>
  )
}
